import { setShowSelectItemDescriptionModal } from '../State/showSelectItemDescriptionModal';
import { setCurrentEstimateItem } from '../State/currentEstimateItem';

export default () => async (dispatch) => {

  dispatch(setShowSelectItemDescriptionModal(false));
  dispatch(setCurrentEstimateItem(null));

}